import styled from '@emotion/styled';

const Container = styled('div')`
  margin: 1.5rem 0px 1rem;
`;

export { Container };
